import { EnumValues } from '@card-software/library';

export function setOptionsForPrimeNg(value: EnumValues) {
  return Object.keys(value).map((key) => {
    const numKey = parseInt(key);
    return {
      label: value[numKey],
      value: numKey,
    };
  });
}
